<template>
<div >
    <p class="title">异议答复</p>
    <div>
        <p>1、查看提疑与澄清信息。</p>
        <img src="../assets/help/1.7.2-1.jpg" alt="">
        <p>2、点击“新增”，打开新增异议页面。</p>
        <img src="../assets/help/1.7.2-2.jpg" alt="">
        <p>3、代理回复后，点击查看按钮查看回复内容。</p>
        <img src="../assets/help/1.7.2-3.jpg" alt="">
    </div>
</div>
</template>
<script>
export default {
    name:'center',
    data(){
        return{
            
        }

    }
}
</script>
<style>

</style>